module.exports = __webpack_public_path__ + "img/miller-wealth-management.80e106ca.svg";